export const TEST_CODE_QUERY = 'TestID';

export const LEGACY_BOOKMARK = 'LegacyBookmark';
export const ETS_BOOKMARK = 'ETSBookmark';
export const LEGACY_GEN0_BOOKMARK = 'LegacyGen0Bookmark';

export const EXTERNAL_LINK_RESPONSE = 'ExternalLinkResponse';
export const SUBJECT_GRADE_INFO_RESPONSE_PROP = 'subjectGradeInfoResponse';
export const TABULAR_RESPONSE_PROP = 'tabularResponse';